export default {
    data() {
      return{
        detailClass: 'h4',
      }
    },
  }